import { Button, Flex, Modal, Radio } from 'antd';
import { useCallback, useState } from 'react';
import { notifyError, notifySuccess } from '../../store/utils';
import { API } from '../../api';

interface ParcelOrderDeleteType {
  lineItemIds: number[];
  visible: boolean;
  onClose: () => void;
  onReload: () => void;
}

const reasonList = [
  { code: 'WRONG_ORDER', text: 'Захиалга буруу хийсэн' },
  { code: 'TEST_ORDER', text: 'Тест захиалга' },
  { code: 'ETC', text: 'Бусад' },
];

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

const ParcelOrderDelete = ({ visible, lineItemIds, onClose, onReload }: ParcelOrderDeleteType) => {
  const [value, setValue] = useState('WRONG_ORDER');
  const [loading, setLoading] = useState(false);
  const close = useCallback(() => {
    onClose();
  }, []);

  const onFinish = useCallback(async () => {
    try {
      setLoading(true);
      await API.delete({ apiVersion: 'api' })(`/order/cancel`, {
        lineItemNoList: lineItemIds,
        reason: value,
      });
      notifySuccess('Захиалга амжилттай цуцаллаа');
      onClose();
      onReload();
    } catch (error: any) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  }, [loading, value, lineItemIds]);

  return (
    <Modal
      title="Баримт устгах шалтгаан сонгох"
      open={visible}
      onCancel={() => close()}
      footer={false}
    >
      <h3>Шалтгаан</h3>
      <Radio.Group onChange={(event) => setValue(event.target.value)} value={value}>
        {reasonList.map((item) => (
          <Radio key={item.code} style={radioStyle} value={item.code}>
            {item.text}
          </Radio>
        ))}
      </Radio.Group>
      <Flex gap={24} justify="end">
        <Button onClick={() => onClose()}>Болих</Button>
        <Button loading={loading} type="primary" onClick={() => onFinish()}>
          Баримт устгах
        </Button>
      </Flex>
    </Modal>
  );
};

export default ParcelOrderDelete;
